<template>
  <div class="pc_only">
    <h2 class="kojin-title"><slot>タイトル</slot></h2>
  </div>
  
  <span class="sp_only">
      <span class="sp-title" style="color:blacka;background: #d8e8fc;" v-on:click="login()">
        ← <slot>タイトル</slot>
        <input type="text" class="form-control" v-if="GlobalData.user_name" v-bind:value="GlobalData.user_name" readonly="readonly">
          <input type="text" class="form-control" v-else-if="GlobalData.$profile" value="未登録" readonly="readonly">
          <input type="text" class="form-control" v-else value="----------------------------------------------------------------------------------" readonly="readonly">
      </span>
    </span>
  <div class="p-2" style="margin-top:0">
    <!-- パンくずリスト -->
    <nav class="pc_only" style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" v-on:click="home" style="cursor:pointer">Home</li>
        <li class="breadcrumb-item" v-on:click="login">ログイン</li>
        <li class="breadcrumb-item active" aria-current="page">{{ title }}</li>
      </ol>
    </nav>
    <div id="manual_area" style="margin-bottom:10px">

    <span v-on:click="manual_open"><img class="m_icon" src="../../images/mark/manual.png"  />ログイン画面のマニュアル</span>
    <span class="pc_only"  v-on:click="qanda_open"><img class="m_icon" src="../../images/mark/QandA.png"  />システムQ&A</span>
    <span class="sp_only"  v-on:click="qanda_open"><img class="m_icon" src="../../images/mark/QandA.png" style="height:35px"  /></span>
    </div>
      <br clear="all">
    <table class="vy-form-table" id="mailform" >
        <!-- メールアドレス -->
        <tr>
          <th>
            <label for="username">パスワードの再設定には認証が必要です。<br>パスワードを再設定したいメールアドレスを入力し、確認用コードを送信してください。</label>
            <!-- v-model="(javascript部分で宣言した変数名)" -->
            <!-- javascript側で変数に変更があった場合、こちらの項目の値も変更される -->
            <!-- 逆にこちらの項目の値を変更すると、変数に代入される-->
            <!-- v-if="(javascript部分で宣言した変数名)" -->
            <!-- v-ifで指定された変数が「True」なら表示、「False」なら非表示 -->
            <input type="text" class="form-control" id="username" name="username" placeholder="example@mail.com" v-model="username">
          </th>
        </tr>
        <tr>
          <td>
            <div class="container">
              <div class="row justify-content-center">
                <div class="col-md-auto"  style="display: flex;justify-content: center;">
                  <button type="submit" class="btn btn-primary mx-aut" style="width: 200px; height: 50px;padding: 0;" v-on:click="Signup()" >送信する</button>
                </div>
              </div>
            </div>
          </td>
        </tr>
              
      </table>


            <div style="color:red;margin-top:20px">
              <b>短時間に3回以上送ると、15分間、認証作業ができなくなります。</b>
            </div>
    </div>
      

      <!--メッセージを表示するモーダルウィンドウ-->
      <component v-bind:is="contentMessage"
                v-bind:message_text="message"
                v-bind:message_cat="message_cat"
                v-bind:message_flag="message_flag"
                @close_message="Close_message"
                @ok_message="OK_message"/>
</template>


<script setup>
/* eslint-disable */
import MessageModal from '../common/MessageModal.vue'
import { GlobalData, login_check } from '../js/userdata.js';
import {
    CognitoUserPool,
    CognitoUser,
    AuthenticationDetails } from 'amazon-cognito-identity-js'
import { ref } from 'vue'
import { useRouter,useRoute } from 'vue-router'
const router = useRouter();
const route = useRoute()

import { useStore } from 'vuex'
const store = useStore()

const cityname = route.params.shakyo

const emit = defineEmits(['call'])

// 属性リスト
const title = "パスワードの再設定";

// 入力された項目
let username = "";           //ユーザー名（メールアドレス）
let password = "";           //パスワード
let password2 = ""; //確認用パスワード
const passtype = ref("password");  //パスワードのタイプ切替
const passvisi = ref(false)

//-------- パスワードの表示／非表示 --------------------
const passcont = () => {
    if (passvisi.value) {
        passtype.value = "password"
    } else {
        passtype.value = "text"
    }
}

let code = ref("")//確認用コード

// 表示・非表示
let form_column = ref(true) // パスワード
let check_column = ref(false) // 確認用コード入力

/* メッセージを表示するモーダルウィンドウ */
let message = ref("")//表示するメッセージ
let message_cat = ref(0)// メッセージのカテゴリ（0：OKのみ、1：OK or キャンセルの選択式）
let message_method = ref("")// こちら（親コンポーネント）に帰った時、どの処理（関数）を行うのか（message_catが1の時のみ）
let message_flag = ref(false)//表示・非表示フラグ
/* 表示する子コンポーネント関係の情報 */
const contentMessage = ref('')// 表示する子コンポーネントの情報（メッセージ表示エリア）
contentMessage.value = null // 表示する子コンポーネント


/* 関数の記述 */
let Page_scroll_login = function(){
// ページの一番上にスクロールする
//「behavior: 'smooth'」はスムーズなスクロール。「behavior: 'auto'」だと一瞬で移動する
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    })
}

// ページトップへスクロール
Page_scroll_login();

let Signup = function() {  // ログイン情報を送信する

    let error_message = "";

    // メールアドレスが入力されているかどうかの確認      
    let mail_regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;//example@mail.comの形式になっているかどうかの確認用
    if(username == ""){
        error_message += "メールアドレスが未入力です。\n"
    }else if (!mail_regex.test(username)) {
        error_message += "メールアドレス以外の値が入力されています。\n"
    }

    // エラーメッセージがあったら処理中断
    if(error_message != ""){
        message.value = error_message;
        message_cat.value = 0;
        message_flag.value = true;
        message_method.value = "validation_error";
        contentMessage.value = MessageModal
        return;
    }


    // 送信するユーザー名（メールアドレス）とパスワードを配列にする
    let authenticationData = {
        Username: username,
        Password: password,
    };

    const poolData = {
        UserPoolId: GlobalData.$UserPoolId,
        ClientId: GlobalData.$ClientId,
    };
    const userPool = new CognitoUserPool(poolData);
    let userData = {
        Username: username,
        Pool: userPool,
    };

    // 送信するユーザー名（メールアドレス）とパスワードの配列を格納(パスワードは空だが一応格納)
    let authenticationDetails = new AuthenticationDetails(authenticationData);
    
    let param = 'cognito-idp.ap-northeast-1.amazonaws.com/' + GlobalData.$UserPoolId;
    
    let cognitoUser = new CognitoUser(userData);
    cognitoUser.forgotPassword({

        onSuccess: function(result) {
          // エラーが無ければコード確認画面へ
          localStorage.setItem('forgot_email', username);
            router.push("/"+cityname+"/Taiken/forgotcode" )
//          emit('call', { cmd:'forgotcode',email:username})
        },
        onFailure: function(err) {
          message.value = "コードの送信の回数制限に達しました。1時間ほど置いてお試しください。";
          message_cat.value = 0;
          message_flag.value = true;
          message_method.value = "validation_error";
          contentMessage.value = MessageModal
              
        }
    });
}

let Verify = function(){
  let error_message = "";
  // 確認用コードが未入力なら処理中断
  if(code.value == "" || code.value == undefined){
    error_message += "確認用コードを入力してください。\n";
  }
  // パスワードが入力されているかどうかの確認
  
  const pass_regex = /^(?=.*?\d)[!-~]{8,}$/ //8文字以上で英数字それぞれを1文字以上含んでいるかどうかの確認用
  const num_regex = /^[0-9]*$/// 数字のみかどうかの確認用
if(password == ""){
    error_message += "パスワードが未入力です。\n"     
  }else if(!pass_regex.test(password)){
    error_message += "パスワードは8文字以上で英数字それぞれを1文字以上含んでください。\n"     
  }else if(num_regex.test(password)){
    error_message += "パスワードは8文字以上で英数字それぞれを1文字以上含んでください。\n"     

  }
  if(password != password2){
      error_message += "パスワードと確認用パスワードが一致しません。"

  }
    // エラーメッセージがあったら処理中断
    if(error_message != ""){
        message.value = error_message;
        message_cat.value = 0;
        message_flag.value = true;
        message_method.value = "validation_error";
        contentMessage.value = MessageModal
        return;
    }


    // 送信するユーザー名（メールアドレス）とパスワードを配列にする
    let authenticationData = {
        Username: username,
        Password: password,
    };

    const poolData = {
        UserPoolId: GlobalData.$UserPoolId,
        ClientId: GlobalData.$ClientId,
    };
    const userPool = new CognitoUserPool(poolData);
    let userData = {
        Username: username,
        Pool: userPool,
    };

    // 送信するユーザー名（メールアドレス）とパスワードの配列を格納(パスワードは空だが一応格納)
    let authenticationDetails = new AuthenticationDetails(authenticationData);
    
    let param = 'cognito-idp.ap-northeast-1.amazonaws.com/' + GlobalData.$UserPoolId;

    let set_code = ("000000"+code.value.toString()).slice(-6)
  
    let cognitoUser = new CognitoUser(userData);
    cognitoUser.confirmPassword(set_code, password, {
        onSuccess: function(result) {
            message.value ="パスワードの再設定が完了しました。ログインフォームよりログインしてください。";
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "renewal_complete";
            contentMessage.value = MessageModal
          
           // ログイン画面へ移動
           //router.push('/Shakyo/Taiken/list')
        },
        onFailure: function(err) {
            if(err == "CodeMismatchException: Invalid verification code provided, please try again."){
              // code_error_message.value = "コード："+code.value+"\n\nエラー\n"+err
              message.value = "認証に失敗しました。確認用コードに不備があります。";
            }else{
              
              message.value = "1時間以内に3回のコード送信を検知しました。\n時間をおいてから再度お試しください。";
            }
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "cognito_error";
            contentMessage.value = MessageModal
        }
    });


}

let home = function(){
  router.push('/'+cityname+'/Taiken')
}

let login = function(){
  router.push('/'+cityname+'/Taiken/login')
}

let OK_message = function(){ // メッセージを表示するウィンドウでOKを押された時
    Close_message();//メッセージを表示するウィンドウを閉じる

    if(message_method.value == "renewal_complete"){
      
      login()
      
    }
}

let Close_message = function(){ // メッセージを表示するウィンドウを閉じる
    message_flag.value = false;
    contentMessage.value = null

  }
  
  let manual_open = function(){
 
 let url = "https://zest-newsprint-e3e.notion.site/15ec0be34f8f802385a5fa78c1c02509"
 window.open(url,"_blank")
}

// Q&Aを開く
const qanda_open = () =>{

let url = "https://zest-newsprint-e3e.notion.site/Q-A-175c0be34f8f801998fac72f169fb66b"
window.open(url,"_blank")
} 
</script>

<style scoped>
	#mailform,#checkform{
		max-width: 800px;
		margin: auto;
		border: 1px solid #000;
	}
	#mailform tr th,#checkform tr th{
		padding: 20px;
	}
	#mailform tr td,#checkform tr td{
		padding-bottom: 25px;
	}
	.checkbox-inline input{
		margin-left: 2px;
		margin-right: 5px;
	}
</style>